"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.exportMetricsExcelFile = exports.handleExportAll = exports.handleExport = void 0;

var _js2excel = require("js2excel"); //Library to export json to xlsx
//https://www.npmjs.com/package/js2excel


var handleExport = function handleExport(fileName, data, excludedColumns) {
  return !data.length ? alert('Sorry, no data to export.') : exportMetricsExcelFile(fileName, data, excludedColumns);
};

exports.handleExport = handleExport;

var handleExportAll = function handleExportAll(requestAllDataCall, paramString, fileName, excludedColumns, transpiler) {
  requestAllDataCall(paramString).then(function (response) {
    //this is the same if statement that is used when setting no data state for charts
    if (!response.data || !response.data.total || !response.data.total.aggregate) {
      alert('Sorry, no data to export.');
    } else {
      exportMetricsExcelFile(fileName, transpiler(response.data), excludedColumns);
    }
  }).catch(function (err) {
    return console.log(err) || alert.displayErrorMessage('There was a problem fetching your data.');
  });
};

exports.handleExportAll = handleExportAll;

var exportMetricsExcelFile = function exportMetricsExcelFile(fileName, data, excludedColumns) {
  //temporary object that will hold each rows data till its appended to resultArray then cleared
  var tempObj = {}; //array that will be used to hold each row and eventually be printed to an excel file

  var resultArray = []; //this forEach will loop through the data and filter each row of all excluded columns then append that row to the resultArray

  data.forEach(function (row) {
    var isPubPortalMetrics = false; //this line will take the 'total' column from the last position and move it to the first position

    if (Object.keys(row)[Object.keys(row).length - 1] === 'total') {
      isPubPortalMetrics = true;
      tempObj[""] = row[Object.keys(row)[Object.keys(row).length - 1]];
    }

    for (var column = 0; column <= Object.keys(row).length - (isPubPortalMetrics ? 2 : 1); column += 1) {
      if (!excludedColumns.includes(Object.keys(row)[column])) {
        tempObj[Object.keys(row)[column]] = row[Object.keys(row)[column]];
      }
    }

    resultArray.push(tempObj);
    tempObj = {};
  }); //this is the method imported from js2xcel that takes in data, filename, and date created

  (0, _js2excel.json2excel)({
    data: resultArray,
    name: fileName,
    formateDate: new Date()
  });
};

exports.exportMetricsExcelFile = exportMetricsExcelFile;